import ViewBase from "../../../../framework/core/mvvm/view_base";
import { SpriteHolderSlot } from "../sprite_holder_slot";
import GameUtil from "../../../../utility/game_util";
import Utility from "../../../../utility/utility";

const { ccclass, property } = cc._decorator;

@ccclass
export class SlotCarryView extends ViewBase {

    @property(cc.Label)
    totalGold: cc.Label = null;

    @property(cc.Label)
    betGold: cc.Label = null;

    @property(cc.Label)
    minGold: cc.Label = null;

    @property(cc.Label)
    maxGold: cc.Label = null;

    @property(cc.Label)
    carryGold: cc.Label = null;

    @property(cc.Sprite)
    goldIcon: cc.Sprite[] = [];

    @property(cc.Slider)
    slider: cc.Slider = null;

    @property(cc.ProgressBar)
    progressBar: cc.ProgressBar = null;

    @property(SpriteHolderSlot)
    spriteHoder: SpriteHolderSlot = null;

    @property(cc.Node)
    progressGrey: cc.Node  = null;

    @property(cc.Button)
    btnReduce: cc.Button  = null;

    @property(cc.Button)
    btnAdd: cc.Button  = null;


    minValue: number
    maxValue: number
    curValue: number
    baseValue: number
    ownGold: number
    forbidden: boolean


    initBaseData(gold, rule) {
        gold = Math.floor(gold)
        let self = this
        this.totalGold.string = Utility.numberFormat(gold)
        this.ownGold = gold
        this.betGold.string = `${rule.payLineNumber * rule.minMultiple} / ${rule.payLineNumber * rule.maxMultiple}`
        this.minValue = rule.payLineNumber * rule.minMultiple + 10
        this.maxValue = rule.payLineNumber * rule.maxMultiple * 100
        this.minValue = this.minValue
        this.forbidden = gold < this.minValue
        if (gold < this.minValue) {
            this.forbiddenView()
        }
        this.minGold.string = Utility.numberFormat(this.minValue)
        this.maxGold.string = Utility.numberFormat(this.maxValue)
        this.curValue = gold < this.maxValue ? (Math.floor(gold / 2) >= this.minValue ? Math.floor(gold / 2) : this.minValue) : this.maxValue / 2
        this.sliderControl(this.curValue, (this.curValue - this.minValue) / (this.maxValue - self.minValue))
        this.slider.node.on('slide', function () {
            self.curValue = self.minValue + Math.floor((self.maxValue - self.minValue) * self.slider.progress)
            if (self.ownGold < self.curValue) {
                self.curValue = self.ownGold
                self.slider.progress = (self.curValue - self.minValue) / (self.maxValue - self.minValue)
            }
            self.setBtnGrey(self.btnReduce, self.slider.progress == 0)
            self.setBtnGrey(self.btnAdd, self.slider.progress == 1)
            self.progressBar.progress = self.slider.progress
            self.carryGold.string = Utility.numberFormat(self.curValue) 
        }, this)
    }

    forbiddenView() {
        this.progressGrey.active = true
        this.sliderControl(0, 0)
        this.setBtnGrey(this.btnReduce, true)
        this.setBtnGrey(this.btnAdd, true)
        this.slider.enabled = false
    }

    setBtnGrey(btn: cc.Button, grey: boolean) {
        btn.interactable = !grey
        btn.enableAutoGrayEffect = grey
    }

    sliderControl(value, proportion) {
        this.slider.progress = proportion
        this.progressBar.progress = proportion
        this.setBtnGrey(this.btnReduce, proportion == 0)
        this.setBtnGrey(this.btnAdd, proportion == 1)
        this.carryGold.string = Utility.numberFormat(value)
        this.curValue = value
    }

    addReduceDeal(add) {
        if (add) {
            let value = this.ownGold > this.maxValue ? this.maxValue : Math.floor(this.ownGold) 
            this.sliderControl(value, (value - this.minValue) / (this.maxValue - this.minValue))
        } else {
            this.sliderControl(this.minValue, 0)
        }
    }


    currencyIcon(str) {
        // for (let i = 0; i < this.goldIcon.length; i++) {
        //     this.spriteHoder.setSprite(this.goldIcon[i], str)
        // }
    }
}
